import {
  declareDatasetExtraFiles,
  deleteDatasetExtraFile,
  finalizeDatasetExtraFiles,
  renameDatasetExtraFile,
} from "@/api";

// 파일 브라우저(FileBrowser)의 extra 파일 write seam. 읽기(폴더 파일 목록, signed URL)는
// `FileBrowserSource` 가 카탈로그와 관계없이 가진다. 이 파일은 멤버가 바꿀 수 있는 extra 파일의
// 쓰기만 둔다. 쓰기는 declare/finalize(업로드), rename, remove 다. 네 개 모두 optional 이다.
// seam 이 없는 스코프에서는 브라우저가 읽기 전용(Download)으로 동작한다.
export type ExtraFileWriteApi = {
  declare?: typeof declareDatasetExtraFiles;
  finalize?: typeof finalizeDatasetExtraFiles;
  rename?: typeof renameDatasetExtraFile;
  remove?: typeof deleteDatasetExtraFile;
};

// 공용 Dataset 의 extra 파일 write. 게이트가 member+ 이므로 Upload/Rename/Delete 를 지원한다
// (declare→PUT→finalize). 등급 검사는 서버가 한다. 이 seam 이 있으면 브라우저가 편집 UI 를 켠다.
export const datasetExtraFileWriteApi: ExtraFileWriteApi = {
  declare: declareDatasetExtraFiles,
  finalize: finalizeDatasetExtraFiles,
  rename: renameDatasetExtraFile,
  remove: deleteDatasetExtraFile,
};
